export enum LocalStorageKeys {
	ResetDate = 'heniNewsResetDate',
	ArticlesViewed = 'heniNewsArticlesViewed',
	UsersToSubscribe = 'heniNewsUsersToSubscribe',
}
